var modules_bbe8aac2 = {"container":"LogoCarousel_module_container__b8347940","logoCarousel":"LogoCarousel_module_logoCarousel__b8347940","tracks":"LogoCarousel_module_tracks__b8347940","tracks--item":"LogoCarousel_module_tracks_Item__b8347940","logotype":"LogoCarousel_module_logotype__b8347940"};
import "../../assets/esm/LogoCarousel/src/LogoCarousel~DyywIO-m.css";

export { modules_bbe8aac2 as default };
//# sourceMappingURL=LogoCarousel.module.less.js.map
